"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpScreen = void 0;
var app_icon_black_png_1 = __importDefault(require("../assets/app_icon_black.png"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var sign_up_1 = require("../api/calls/sign_up");
// import { ButtonControl } from "../controls/button/button";
// import { TextInputControl } from "../controls/textinput/textinput";
var message_1 = require("../controls/modal/message");
var react_router_dom_1 = require("react-router-dom");
var login_background_png_1 = __importDefault(require("../assets/login_background.png"));
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var user_1 = require("../reducers/slices/user");
var doshx_controls_web_1 = require("doshx_controls_web");
var SignUpScreen = function () {
    var cookies = new universal_cookie_1.default();
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var userState = (0, react_redux_1.useSelector)(function (state) { return state.userState; });
    var _a = (0, react_1.useState)(false), isBusy = _a[0], setIsBusy = _a[1];
    var _b = (0, react_1.useState)(""), confirmPassword = _b[0], setConfirmPassword = _b[1];
    var _c = (0, react_1.useState)(""), emailErrorText = _c[0], setEmailErrorText = _c[1];
    var _d = (0, react_1.useState)(""), passwordErrorText = _d[0], setPasswordErrorText = _d[1];
    var _e = (0, react_1.useState)(""), confirmPasswordErrorText = _e[0], setConfirmPasswordErrorText = _e[1];
    var _f = (0, react_1.useState)({
        title: "",
        isOpen: false,
        messages: [],
    }), messageModalData = _f[0], setMessageModalData = _f[1];
    (0, react_1.useEffect)(function () {
        //
    }, []);
    var onControlChanged = function (name, value) {
        var _a;
        dispatch((0, user_1.setUser)(__assign(__assign({}, userState.user), { admin: __assign(__assign({}, userState.user.admin), (_a = {}, _a[name] = value, _a)) })));
        // setUserState({
        //   ...userState,
        //   [name]: value,
        // })
    };
    var validate = function () {
        var errorCount = 0;
        setEmailErrorText("");
        setPasswordErrorText("");
        setConfirmPasswordErrorText("");
        if (!userState.user.admin.email) {
            errorCount++;
            setEmailErrorText("Email is required");
        }
        if (!userState.user.admin.password) {
            errorCount++;
            setPasswordErrorText("Password is required");
        }
        if (!confirmPassword) {
            errorCount++;
            setConfirmPasswordErrorText("Confirm Password is required");
        }
        if (confirmPassword != userState.user.admin.password) {
            errorCount++;
            setPasswordErrorText("Passwords does not match");
            setConfirmPasswordErrorText("Passwords does not match");
        }
        if (errorCount > 0) {
            return false;
        }
        else {
            return true;
        }
    };
    return (react_1.default.createElement("div", { className: "flex-col lg:flex-row xl:flex-row\n                 flex w-full" },
        react_1.default.createElement("div", { className: "relative w-full h-full bg-black flex justify-start items-end" },
            react_1.default.createElement("img", { className: "absolute object-cover w-full h-full", src: login_background_png_1.default }),
            react_1.default.createElement("div", { className: "absolute top-4 left-4" },
                react_1.default.createElement("img", { className: "w-28 object-cover rounded-full", src: app_icon_black_png_1.default })),
            react_1.default.createElement("div", { className: "absolute bottom-4 left-4 text-5xl text-white" }, "Welcome")),
        react_1.default.createElement("div", { className: "lg:w-login-side xl:w-login-side p-4\n                   flex flex-col justify-center px-4 space-y-4" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", value: userState.user.admin.email, errorText: emailErrorText, onChange: function (v) { return onControlChanged("email", v); } }),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Password", value: userState.user.admin.password, type: "password", errorText: passwordErrorText, onChange: function (v) { return onControlChanged("password", v); } }),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Confirm Password", value: confirmPassword, type: "password", errorText: confirmPasswordErrorText, onChange: function (v) { return setConfirmPassword(v); } }),
            react_1.default.createElement("div", { className: "h-4" }),
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Sign Up", loading: isBusy, onClick: function () {
                    if (validate()) {
                        setIsBusy(true);
                        (0, sign_up_1.sign_up)({
                            email: userState.user.admin.email.trim(),
                            password: userState.user.admin.password.trim(),
                        }).then(function (response) {
                            setIsBusy(false);
                            if (response.data.success) {
                                //                   console.log("response.data.content", response.data.content);
                                var recipe = __assign(__assign(__assign({}, userState.user), response.data.content), { admin: __assign(__assign({}, userState.user.admin), response.data.content.admin) });
                                //                   console.log("recipe login", recipe);
                                dispatch((0, user_1.setUser)(recipe));
                                cookies.set("user", recipe, {
                                    sameSite: true,
                                });
                                navigate("/console");
                            }
                            else {
                                setMessageModalData(__assign(__assign({}, messageModalData), { title: "Something went wrong!", isOpen: true, messages: [response.data.message] }));
                            }
                        });
                    }
                } }),
            react_1.default.createElement("div", { className: "flex justify-center" },
                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Go back to log in", onClick: function () {
                        navigate("/login");
                    } }))),
        react_1.default.createElement(message_1.MessageModalControl, __assign({}, messageModalData, { close: {
                showClose: true,
                onClose: function () {
                    setMessageModalData(__assign(__assign({}, messageModalData), { isOpen: false }));
                },
            } }))));
};
exports.SignUpScreen = SignUpScreen;
